import api from '.';
import { Account, MemberRegisterCredentials, Message } from '@karehero/models';

export const iamApi = api.injectEndpoints({
  endpoints: (builder) => ({
    registerMemberByInviteKey: builder.mutation<
      Message,
      { organizationID?: string; inviteKey: string }
    >({
      query: (credentials) => ({
        url: '/register/member/invite-key',
        method: 'POST',
        body: credentials,
      }),
      invalidatesTags: ['Accounts', 'CareCircles', 'OrganizationMembers'],
    }),
    registerMemberByDomain: builder.mutation<
      { isInviteCode: boolean },
      MemberRegisterCredentials
    >({
      query: (createMember) => ({
        url: '/register/member/domain',
        method: 'POST',
        body: createMember,
      }),
    }),
    registerMemberByInviteMagicLink: builder.mutation<
      Account,
      { token: string }
    >({
      query: (credentials) => ({
        url: '/register/member/invite/magic-link',
        method: 'POST',
        body: credentials,
      }),
    }),
    signInKinde: builder.mutation<Account, {}>({
      query: (credentialsKinde) => ({
        url: '/sign-in',
        method: 'POST',
        body: credentialsKinde,
      }),
    }),
    signOut: builder.mutation<Message, void>({
      query: () => ({
        url: '/sign-out',
        method: 'POST',
      }),
    }),
    updateIsOnboarded: builder.mutation<Message, void>({
      query: () => ({
        url: '/onboarded',
        method: 'POST',
      }),
    }),
    version: builder.query<Message, void>({
      query: () => `/version`,
    }),
    updateCareCircleNames: builder.mutation<
      { careRecipientFirstName: string },
      { careRecipientFirstName: string }
    >({
      query: (res) => ({
        url: `/care-circle/names`,
        method: 'PUT',
        body: res,
      }),
      invalidatesTags: ['CareCircles'],
    }),
  }),
});

export const {
  useRegisterMemberByInviteKeyMutation,
  useRegisterMemberByDomainMutation,
  useRegisterMemberByInviteMagicLinkMutation,
  useSignInKindeMutation,
  useSignOutMutation,
  useUpdateIsOnboardedMutation,
  useLazyVersionQuery,
  useUpdateCareCircleNamesMutation,
} = iamApi;

export default iamApi;
